/**
 * Host detection.
 *
 * One bundle serves every surface; which one a visitor gets is decided by the
 * hostname, exactly as the API decides which tenant a request belongs to. That
 * keeps the two in step: there is no way to be on a venue's subdomain and see
 * the operator panel.
 */

export type Surface = "operator" | "venue";

/** The operator subdomain, mirroring OPERATOR_SUBDOMAIN on the API. */
const OPERATOR_SUBDOMAIN = "admin";

export function currentSurface(hostname: string = window.location.hostname): Surface {
  return hostname.split(".")[0] === OPERATOR_SUBDOMAIN ? "operator" : "venue";
}

/** The venue slug from the hostname, or null on the operator host. */
export function currentSlug(hostname: string = window.location.hostname): string | null {
  const [first, ...rest] = hostname.split(".");
  if (rest.length === 0 || first === OPERATOR_SUBDOMAIN) return null;
  return first;
}
